export const TOKEN_BACKOFFICE = 'backoffice.2fa.rememberme';
